import _Set from "@babel/runtime-corejs3/core-js/set";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { getField } from "@joandvgv/vuex-map-fields";
import { cloneDeep, forOwn, isArray, isEmpty, map, orderBy, pickBy, values, find } from "lodash";
export const TRIGGERS_WITH_AUTOMATION = "TRIGGERS_WITH_AUTOMATION";
export const AUTOMATIONS_BY_TRIGGER = "AUTOMATIONS_BY_TRIGGER";
export const TRIGGER_BY_KEY = "TRIGGER_BY_KEY";
export const ACTION_BY_KEY = "ACTION_BY_KEY";
export const AUTOMATION_CLEAN = "AUTOMATION_CLEAN";
export const IS_EMAIL_SYNCED = "IS_EMAIL_SYNCED";
export const EMAIL_SIGNATURE = "EMAIL_SIGNATURE";
export const AUTOMATION_BY_PATH = "AUTOMATION_BY_PATH";
export const AUTOMATION_DATA_BY_LEVEL = "AUTOMATION_DATA_BY_LEVEL";
export const DOCUMENT_REQUESTS_AUTOMATIONS = "DOCUMENT_REQUESTS_AUTOMATIONS";
export const DOCUMENT_REQUEST_AUTOMATION = "DOCUMENT_REQUEST_AUTOMATION";
export const DOCUMENT_REQUEST_AUTOMATION_DESCRIPTION = "DOCUMENT_REQUEST_AUTOMATION_DESCRIPTION";
export const DOCUMENT_REQUEST_AUTOMATION_NAME = "DOCUMENT_REQUEST_AUTOMATION_NAME";
export const DOCUMENT_REQUEST_AUTOMATION_RULES = "DOCUMENT_REQUEST_AUTOMATION_RULES";
export const DOCUMENT_REQUESTS_AUTOMATIONS_FOR_RULE = "DOCUMENT_REQUESTS_AUTOMATIONS_FOR_RULE";
export const DOCUMENT_REQUEST_AUTOMATION_SCHEMA_RULES = "DOCUMENT_REQUEST_AUTOMATION_SCHEMA_RULES";
export const DOCUMENT_REQUEST_AUTOMATION_SCHEMA = "DOCUMENT_REQUEST_AUTOMATION_SCHEMA";
export const IS_DOCUMENT_REQUEST_EDIT_MODE = "IS_DOCUMENT_REQUEST_EDIT_MODE";
export const DOCUMENT_REQUEST_RULE_HAS_DOCUMENTS = "DOCUMENT_REQUEST_RULE_HAS_DOCUMENTS";
const getters = {
  getField,
  [AUTOMATION_DATA_BY_LEVEL]: state => (level = "board") => {
    const automationsByLevel = {
      board: state.automationData,
      application: state.appAutomationData
    };
    return automationsByLevel[level];
  },
  [TRIGGERS_WITH_AUTOMATION]: (state, getters) => level => {
    const triggers = new _Set();
    const automationData = getters.AUTOMATION_DATA_BY_LEVEL(level);
    const automations = automationData.entities.automation;
    const orderedAutomations = orderBy(automations, automation => {
      var _automation$triggerA, _automation$triggerA2, _automation$triggerA3;
      return ((_automation$triggerA = automation["trigger-arguments"]) == null ? void 0 : _automation$triggerA.board) && ((_automation$triggerA2 = automation["trigger-arguments"]) == null ? void 0 : (_automation$triggerA3 = _automation$triggerA2.board) == null ? void 0 : _automation$triggerA3["desc"]);
    });
    forOwn(orderedAutomations, automation => {
      triggers.add(automation.trigger);
    });
    return [...triggers];
  },
  [TRIGGER_BY_KEY]: (state, getters) => (key, level) => {
    return getters.AUTOMATION_DATA_BY_LEVEL(level).entities.trigger[key];
  },
  [ACTION_BY_KEY]: (state, getters) => (key, level) => {
    return getters.AUTOMATION_DATA_BY_LEVEL(level).entities.action[key];
  },
  [AUTOMATIONS_BY_TRIGGER]: (state, getters) => (trigger, level) => {
    const automationData = getters.AUTOMATION_DATA_BY_LEVEL(level).entities.automation;
    if (isEmpty(automationData)) return [];
    return values(pickBy(automationData, automation => automation.trigger === trigger));
  },
  [AUTOMATION_CLEAN]: state => (data = {}) => {
    const typesToIgnore = ["checklist", "assignees", "assigned"];
    const typesToConvertIfUpdating = ["status", "board"];
    if (!isEmpty(data)) typesToConvertIfUpdating.push("offset");
    const typesToAlwaysConvert = ["status", "board"];
    const automation = isEmpty(data) ? cloneDeep(state.currentAutomation) : cloneDeep(data);
    automation["trigger-arguments"] = automation.triggerArguments || {};
    automation["action-arguments"] = automation.actionArguments || {};
    delete automation.triggerArguments;
    delete automation.actionArguments;
    const valueConverter = (value, key, obj) => {
      const isEditingProperty = (state.editing || !isEmpty(data)) && _includesInstanceProperty(typesToConvertIfUpdating).call(typesToConvertIfUpdating, key);
      if (isEditingProperty || _includesInstanceProperty(typesToAlwaysConvert).call(typesToAlwaysConvert, key)) {
        value = [value];
      }
      if (isArray(value) && !_includesInstanceProperty(typesToIgnore).call(typesToIgnore, key)) {
        obj[key] = map(value, arg => arg.value + "");
      }
    };
    automation.action = automation.action.key;
    automation.trigger = automation.trigger.key;
    forOwn(automation["trigger-arguments"], valueConverter);
    forOwn(automation["action-arguments"], valueConverter);
    automation.shared = isEmpty(data) ? state.currentAutomation.shared : automation.shared;
    delete automation.owner;
    return automation;
  },
  [IS_EMAIL_SYNCED]: state => !isEmpty(state.emailsSynced),
  [EMAIL_SIGNATURE]: state => {
    const signature = state.emailSignature;
    return isEmpty(signature) ? "" : signature;
  },
  [AUTOMATION_BY_PATH]: state => path => find(state.automationData.entities.automation, [path.path, path.value]),
  [DOCUMENT_REQUESTS_AUTOMATIONS]: state => {
    return state.documentRequestAutomations;
  },
  [DOCUMENT_REQUESTS_AUTOMATIONS_FOR_RULE]: state => requestType => {
    const {
      byId: documentRequestAutomations = {},
      allIds: documentRequestAutomationsIds = []
    } = state.documentRequestAutomations;
    return _reduceInstanceProperty(documentRequestAutomationsIds).call(documentRequestAutomationsIds, (acc, automationId) => {
      const documentAutomation = documentRequestAutomations[automationId];
      if (documentAutomation) {
        const includeRule = documentAutomation.documentRequestRule.rules.some(rule => rule.type === requestType);
        return includeRule ? [...acc, documentAutomation] : acc;
      }
      return acc;
    }, []);
  },
  [DOCUMENT_REQUEST_AUTOMATION]: state => id => {
    const {
      documentRequestAutomations
    } = state;
    return (documentRequestAutomations == null ? void 0 : documentRequestAutomations.byId[id]) || {};
  },
  [DOCUMENT_REQUEST_AUTOMATION_RULES]: (state, getters) => id => {
    var _documentRequestAutom;
    const documentRequestAutomation = getters[DOCUMENT_REQUEST_AUTOMATION](id);
    return ((_documentRequestAutom = documentRequestAutomation.documentRequestRule) == null ? void 0 : _documentRequestAutom.rules) || [];
  },
  [DOCUMENT_REQUEST_AUTOMATION_SCHEMA_RULES]: state => {
    const {
      byId,
      allIds
    } = state.documentRequestAutomationSchema;
    return {
      byId: byId.rules,
      allIds
    };
  },
  [DOCUMENT_REQUEST_AUTOMATION_SCHEMA]: state => {
    return state.documentRequestAutomationSchema;
  },
  [IS_DOCUMENT_REQUEST_EDIT_MODE]: state => id => {
    return state.documentRequestEditMode[id];
  },
  [DOCUMENT_REQUEST_RULE_HAS_DOCUMENTS]: (state, getters) => id => {
    const documentRequestAutomation = getters[DOCUMENT_REQUEST_AUTOMATION](id);
    return (documentRequestAutomation == null ? void 0 : documentRequestAutomation.documentRequestRule.documents.length) > 0;
  }
};
export default getters;